module.exports = __webpack_public_path__ + "img/button_zanting.a9e433a5.png";